import { render, staticRenderFns } from "./ControleBnpBarra.vue?vue&type=template&id=18bec328&scoped=true&"
import script from "./ControleBnpBarra.vue?vue&type=script&lang=js&"
export * from "./ControleBnpBarra.vue?vue&type=script&lang=js&"
import style0 from "./ControleBnpBarra.vue?vue&type=style&index=0&id=18bec328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bec328",
  null
  
)

export default component.exports